import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SectionWrapper from '../../components/atoms/SectionWrapper';
import BiddingPostsTable from '../../components/BiddingPosts/BiddingPostsTable';

export default function BiddingPostsPage() {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <SectionWrapper
      title={t('biddingPosts.pageTitle')}
      desc={t('biddingPosts.pageDesc')}
      whiteBgChildren
      data-testid="bidding-posts-page"
    >
      <BiddingPostsTable key={location.pathname} />
    </SectionWrapper>
  );
}
